/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import {
    Card, Checkbox,
    Col,
    Form,
    Radio,
    Row,
    Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const { Text } = Typography;

/** P625 model / torch values — TPS3200 uses legacy keys; TPS400i uses dedicated key for spare-parts tabs. */
const P625_MODEL_TPS3200 = 'TPS3200';
const P625_MODEL_TPS400I = 'TPS400i';
const P625_TORCH_TPS400I_ONLY = 'TPS400i_ORIG_TORCH';

/** Spare-parts tab names (match database / overview) */
const FULL_SCOPE_GOUGING = 'Full scope Gouging';
const FULL_SCOPE_STT = 'Full scope STT';
const REPAIR_GOUGING = 'Repair Gouging';

//const { Option } = Select;
const WeldingForm = (props) => {

    const {
        Specification,
        partsData,
        setPartsData,
        activeLine,
        weldingData,
        isEdit
    } = props;


    const [selectedOptions, setSelectedOptions] = useState({
        m_Series: [], // M-500, M-400, M-300
        M300: {
            enabled: false,
            Process: "",
            Manufacturer: ""
        },
        M400: {
            enabled: false,
            Process: "",
            Manufacturer: ""
        },
        M500: {
            enabled: false,
            Process: "", // FCAW or STT
            Manufacturer: "" // MILLER or LINCOLN (only if Process is FCAW)
        },
        P600: {
            enabled: false,
        }, // '' or 'P-600'
        P625: {
            P_625: "",
            Torch: "",
            P625_Model: P625_MODEL_TPS3200, // TPS3200 | TPS400i
            CMT_Torch: "",
            CMT_Material: "",
            CMT_Wire_Size: ""
        },
        ManualRepairs: {
            enabled: false,
            options: [] // MMA, GTAW, FCAW, repair gouging
        },
        ManualFullScope: {
            enabled: false,
            options: [] // MMA, GTAW, FCAW, Full scope Gouging, Full scope STT
        }
    });

    useEffect(() => {
       // console.log('weldingData',weldingData)
        if (isEdit && weldingData) {
            const data = weldingData[activeLine]?.Welding
           // console.log('weldingData', isEdit, data, selectedOptions)
           

            if (isEdit && data) {

                const weldingData = data?.WeldingData
                const m_500 = weldingData?.M500 ?  weldingData?.M500 : {
                    enabled: data.m_Series.includes('M-500'),
                    Process: "FCAW",
                    Manufacturer: "MILLER"
                };
                const m_400 = weldingData?.M400 ?  weldingData?.M400 : {
                    enabled: data.m_Series.includes('M-400'),
                };
                const p_600 = weldingData?.P600 ?  weldingData?.P600 : {
                    enabled: data.m_Series.includes('P-600'),
                };
                const rawMr = weldingData?.ManualRepairs ?? { enabled: false, options: [] };
                const manualRepairsData = {
                    ...rawMr,
                    options: (rawMr.options || []).map((o) => (o === 'Gouging' ? 'repair gouging' : o))
                };
                const rawFs = weldingData?.ManualFullScope ?? { enabled: false, options: [] };
                const manualFullScopeData = { ...rawFs, options: rawFs.options || [] };
               
                setSelectedOptions(prevState => ({
                    ...prevState,
                    m_Series: data.m_Series ? (Array.isArray(data.m_Series) ? data.m_Series : data.m_Series.split(',')) : [],
                    M500: { ...prevState.M500, ...m_500 },
                    M400: { ...prevState.M400, ...m_400 },
                    M300: { ...prevState.M300, enabled: (data.m_Series ? (Array.isArray(data.m_Series) ? data.m_Series : data.m_Series.split(',')) : []).includes('M-300') },
                    P600: typeof p_600 === 'object' && p_600 != null ? { enabled: !!p_600.enabled } : { enabled: false },
                    P625:
                    {
                        ...weldingData?.P625,
                        P_625: data.P_625 ?? weldingData?.P625?.P_625,
                        Torch: data.Torch ?? weldingData?.P625?.Torch,
                        P625_Model: data.P625_Model ?? weldingData?.P625?.P625_Model
                            ?? (data.CMT_Torch === P625_TORCH_TPS400I_ONLY || weldingData?.P625?.CMT_Torch === P625_TORCH_TPS400I_ONLY
                                ? P625_MODEL_TPS400I : P625_MODEL_TPS3200),
                        CMT_Torch: data.CMT_Torch ?? weldingData?.P625?.CMT_Torch,
                        CMT_Material: data.CMT_Material ?? weldingData?.P625?.CMT_Material,
                        CMT_Wire_Size: data.CMT_Wire_Size ?? weldingData?.P625?.CMT_Wire_Size
                    },
                    ManualRepairs: manualRepairsData,
                    ManualFullScope: manualFullScopeData
                }));
            }
        }

    }, [weldingData, activeLine])

    useEffect(() => {
        if (Specification) {
            setPartsData((prevOptions) => {


                return {
                    ...prevOptions,
                    [`Line_${activeLine + 1}`]: {
                        ...prevOptions[`Line_${activeLine + 1}`],
                        WeldingData: selectedOptions
                    }
                };
            });
            // Update the state or perform any other actions with the updated partsData
        }
    }, [selectedOptions, Specification, activeLine]);

    const handleCheckboxChange = (category, checkedValues) => {
        setSelectedOptions((prevOptions) => {
            if (category === 'ManualRepairs' || category === 'ManualFullScope') {
                return {
                    ...prevOptions,
                    [category]: {
                        ...prevOptions[category],
                        options: checkedValues,
                        enabled: checkedValues.length > 0
                    }
                };
            }
            if (category === 'm_Series') {
                const series = Array.isArray(checkedValues) ? checkedValues : [];
                return {
                    ...prevOptions,
                    m_Series: series,
                    M300: { ...prevOptions.M300, enabled: series.includes('M-300') },
                    M400: { ...prevOptions.M400, enabled: series.includes('M-400') },
                    M500: { ...prevOptions.M500, enabled: series.includes('M-500') }
                };
            }
            return {
                ...prevOptions,
                [category]: checkedValues,
            };
        });
    };
    const handleHeaderCheckboxChange = (category, isChecked, value) => {
        setSelectedOptions(prevOptions => {
            if (isChecked) {
                return { ...prevOptions, [category]: value };
            }
            if (category === 'P600' && typeof prevOptions.P600 === 'object') {
                return { ...prevOptions, P600: { enabled: false } };
            }
            return {
                ...prevOptions,
                [category]: typeof prevOptions[category] === 'object' && !Array.isArray(prevOptions[category]) ? {} : (Array.isArray(prevOptions[category]) ? [] : ''),
            };
        });
    };

    const handleCheckboxChange1 = (category, type, checkedValues) => {


        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                [category]: {
                    ...prevOptions[category],
                    [type]: checkedValues,
                },
            };
        });
    };
    const updateP625Value = (category, isChecked) => {
        setSelectedOptions((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };

            if (!isChecked && category == 'P625') {

                // If the checkbox is unchecked, clear the values for those types
                updatedCategory['P_625'] = '';
                updatedCategory['Torch'] = ''; // Clear value
                updatedCategory['P625_Model'] = P625_MODEL_TPS3200;
                updatedCategory['CMT_Torch'] = ''; // Clear value
                updatedCategory['CMT_Material'] = ''; // Clear value
                updatedCategory['CMT_Wire_Size'] = ''; // Clear value
            }

            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });

    }
    const handleHeaderCheckboxChange1 = (category, type, isChecked, value) => {

        setSelectedOptions((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };

            if (isChecked) {
                // Add values when the header checkbox is checked
                if (!isArrayNotEmpty(category, type))
                    updatedCategory[type] = value;
            }
            else {
                updatedCategory[type] = '';
            }

            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });
    }

    const handleRadioChange = (category, type, value) => {
        if (!getCategoryValue1('P625', 'CMT_Torch') || !getCategoryValue1('P625', 'CMT_Material') || !!getCategoryValue1('P625', 'CMT_Wire_Size')) {
            handleHeaderCheckboxChange1('P625', 'CMT_Torch', isArrayNotEmpty('P625', "P_625"), 'F-ORIG')
            handleHeaderCheckboxChange1('P625', 'CMT_Material', isArrayNotEmpty('P625', "P_625"), 'CS')
            handleHeaderCheckboxChange1('P625', 'CMT_Wire_Size', isArrayNotEmpty('P625', "P_625"), '1.0')
        }
        setSelectedOptions((prevOptions) => {

            return {
                ...prevOptions,
                [category]: {
                    ...prevOptions[category],
                    [type]: value,
                },
            };

        });
        // console.log(category, value, selectedOptions)
    };

    const handleTorchRadioChange = (category, type, value) => {

        setSelectedOptions((prevOptions) => {

            return {
                ...prevOptions,
                [category]: {
                    ...prevOptions[category],
                    [type]: value,
                },
            };

        });
        // console.log(category, value, selectedOptions)
    };


    const isArrayNotEmpty = (category, type) => {
        return (
            selectedOptions.hasOwnProperty(category) && // Check if the category exists in selectedOptions
            selectedOptions[category][type] != '' // Check if the array is not empty
        );
    };
    const isArrayNotEmpty1 = (category, type) => {
        return selectedOptions[category] && Array.isArray(selectedOptions[category][type]) && selectedOptions[category][type].length > 0;
    };

    const getCategoryValue = (category) => {
        if (selectedOptions.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            return selectedOptions[category]; // Return the value for the category
        } else {
            return null; // Return null if the category does not exist
        }
    };
    const getCategoryValue1 = (category, type) => {
        if (selectedOptions.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            if (selectedOptions[category] && typeof selectedOptions[category] === 'object' && !Array.isArray(selectedOptions[category])) {
                return selectedOptions[category][type] || null; // Return the value for the category
            }
            return null;
        } else {
            return null; // Return null if the category does not exist
        }
    };
    const isArrayContainValue1 = (category, type) => {
        return (
            selectedOptions[category] &&
                Array.isArray(selectedOptions[category][type])
                ? selectedOptions[category][type]
                : []
        );
    };
    const isAnyPropertyWithValue = () => {
        return (

            isArrayNotEmpty('P625', 'CMT_Torch') || isArrayNotEmpty('P625', 'CMT_Material') ||
            isArrayNotEmpty('P625', 'CMT_Wire_Size')
        );
    };

    const getP625DefaultCmtTorch = () => {
        const model = getCategoryValue1('P625', 'P625_Model');
        return model === P625_MODEL_TPS400I ? P625_TORCH_TPS400I_ONLY : 'F-ORIG';
    };

    const handleP625ModelChange = (model) => {
        setSelectedOptions((prevOptions) => {
            const p = prevOptions.P625 || {};
            let nextTorch = p.CMT_Torch;
            if (model === P625_MODEL_TPS400I) {
                if (![P625_TORCH_TPS400I_ONLY].includes(nextTorch)) nextTorch = P625_TORCH_TPS400I_ONLY;
            } else if (model === P625_MODEL_TPS3200) {
                if (nextTorch === P625_TORCH_TPS400I_ONLY || !nextTorch) nextTorch = 'F-ORIG';
            }
            return {
                ...prevOptions,
                P625: {
                    ...p,
                    P625_Model: model,
                    CMT_Torch: nextTorch
                }
            };
        });
    };

    const handleM500ProcessChange = (value) => {
        setSelectedOptions((prevOptions) => {
            const updatedM500 = { ...prevOptions.M500 };
            updatedM500.Process = value;
            // Clear Manufacturer when process changes, user will select again
            updatedM500.Manufacturer = '';
            return {
                ...prevOptions,
                M500: updatedM500
            };
        });
    };

    const handleM500ManufacturerChange = (value) => {
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                M500: {
                    ...prevOptions.M500,
                    Manufacturer: value
                }
            };
        });
    };

    const handleM400ProcessChange = (value) => {
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                M400: {
                    ...prevOptions.M400,
                    Process: value
                }
            };
        });
    };

    const handleM400ManufacturerChange = (value) => {
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                M400: {
                    ...prevOptions.M400,
                    Manufacturer: value
                }
            };
        });
    };

    const isM500Selected = () => {
        return getCategoryValue('m_Series')?.includes('M-500');
    };

    const isM400Selected = () => {
        return getCategoryValue('m_Series')?.includes('M-400');
    };

    return (


        <div className="pipeline-modal">

            <div style={{ marginTop: '-10px' }}>
                <Row justify="start">
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="mb-0" style={{ fontSize: '18px' }}>Specification :</p>

                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">Pipe Size(inch)</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col1}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">Wall Thickness(mm)</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col2}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">No. of Welds</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col3}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">No. of Station</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col4}</p>
                            </div>
                        </div>
                    </Col>



                </Row>
            </div>
            <div className="custom-line" style={{ marginTop: '-10px' }} />
            <Form

                name="basic"
                autoComplete="off"
                width='100%'
                style={{ marginTop: '-10px' }}
            >



                <Card
                    className="custom-card2"
                    title="EWM"
                    style={{ background: 'rgba(255, 255, 255, 0.1)', minHeight: '500px', fontSize: '20px' }}
                    bodyStyle={{
                        maxHeight: 'calc(100vh - 300px)',
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    }}
                >
                    <Row gutter={24}>
                        {/* Left Column - Main Options */}
                        <Col lg={4}>
                            <Checkbox.Group style={{ display: 'grid', fontSize: '10px' }} value={getCategoryValue('m_Series')}
                                onChange={(checkedValues) => handleCheckboxChange('m_Series', checkedValues)}>
                                <Checkbox style={{ fontSize: '15px' }} value='M-500'>M-500</Checkbox>
                                <Checkbox style={{ fontSize: '16px', marginLeft: '-0px', paddingTop: '20px' }} value='M-400'>M-400</Checkbox>
                                <Checkbox style={{ fontSize: '16px', marginLeft: '-0px', paddingTop: '20px' }} value='M-300'>M-300</Checkbox>
                            </Checkbox.Group>

                            <div style={{ display: 'grid', fontSize: '10px', paddingTop: '20px' }} className='report-radio'>
                                <Checkbox style={{ fontSize: '16px', marginLeft: '-0px' }} checked={selectedOptions.P600?.enabled ?? false}
                                    onChange={(e) => handleHeaderCheckboxChange('P600', e.target.checked, { enabled: true })}>P-600</Checkbox>
                            </div>

                            <div style={{ display: 'grid', fontSize: '10px', paddingTop: '20px' }} className='report-radio'>
                                <Checkbox style={{ fontSize: '16px', marginLeft: '-0px' }} checked={isArrayNotEmpty('P625', "P_625")}
                                    onChange={(e) => {
                                        updateP625Value("P625", e.target.checked)
                                        handleHeaderCheckboxChange1('P625', 'P_625', e.target.checked, 'P-625')
                                        handleHeaderCheckboxChange1('P625', 'Torch', e.target.checked, 'Single Torch')
                                    }
                                    }>P625</Checkbox>
                            </div>



                        </Col>

                        {/* Middle Column - Process and Manufacturer Selection */}
                        <Col lg={12}>
                            {/* M-500 Flow */}
                            {isM500Selected() && (
                                <div style={{ paddingBottom: '5px' }}>
                                    <Form.Item style={{ paddingTop: '0px', paddingLeft: '0px', cursor: 'default' }}
                                        label='Process Type:'
                                        className='report-radio'
                                    >
                                        <Radio.Group
                                            style={{ display: "flex" }}
                                            value={getCategoryValue1('M500', 'Process')}
                                            onChange={(e) => handleM500ProcessChange(e.target.value)}
                                        >
                                            <Radio value='FCAW'>FCAW</Radio>
                                            <Radio value='STT'>STT</Radio>
                                        </Radio.Group>
                                    </Form.Item>

                                    {getCategoryValue1('M500', 'Process') === 'FCAW' && (
                                        <Form.Item style={{ paddingTop: '-10px', paddingLeft: '0px', cursor: 'default' }}
                                            label='Manufacturer:'
                                            className='report-radio'
                                        >
                                            <Radio.Group
                                                style={{ display: "flex" }}
                                                value={getCategoryValue1('M500', 'Manufacturer')}
                                                onChange={(e) => handleM500ManufacturerChange(e.target.value)}
                                            >
                                                <Radio value='MILLER'>Miller</Radio>
                                                <Radio value='LINCOLN'>Lincoln</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    )}
                                </div>
                            )}


                            {/* P625 Section */}
                            {isArrayNotEmpty('P625', "P_625") && (
                                <div style={{ display: 'grid', fontSize: '10px' }} className='report-radio'>
                                    <Form.Item style={{ paddingTop: '0px', paddingLeft: '0px', cursor: 'default' }}
                                        label='Torch Type:'
                                        className='report-radio'
                                    >
                                        <Radio.Group style={{ display: "flex" }} value={getCategoryValue1('P625', 'Torch')}
                                            onChange={(e) => handleTorchRadioChange('P625', 'Torch', e.target.value)} >
                                            <Radio value='Single Torch'>Single </Radio>
                                            <Radio value='Dual Torch'>Dual</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    <Form.Item style={{ paddingTop: '5px', paddingLeft: '0px', cursor: 'default' }}
                                        label='Power source:'
                                        className='report-radio'
                                    >
                                        <Radio.Group
                                            style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}
                                            value={getCategoryValue1('P625', 'P625_Model') || P625_MODEL_TPS3200}
                                            onChange={(e) => handleP625ModelChange(e.target.value)}
                                        >
                                            <Radio value={P625_MODEL_TPS3200}>TPS 3200</Radio>
                                            <Radio value={P625_MODEL_TPS400I}>TPS400i</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    <div style={{ display: 'grid', fontSize: '10px', paddingLeft: '80px' }}>
                                        <Checkbox style={{ fontSize: '18px' }} checked={isAnyPropertyWithValue()}
                                            onChange={(e) => {
                                                const defTorch = getP625DefaultCmtTorch();
                                                handleHeaderCheckboxChange1('P625', 'CMT_Torch', e.target.checked, defTorch);
                                                handleHeaderCheckboxChange1('P625', 'CMT_Material', e.target.checked, 'CS');
                                                handleHeaderCheckboxChange1('P625', 'CMT_Wire_Size', e.target.checked, '1.0');
                                            }} >CMT</Checkbox>

                                        <Form.Item style={{ paddingTop: '10px', paddingLeft: '20px', cursor: 'default' }}
                                            label='Torch:'
                                            className='report-radio'
                                        >
                                            <div style={{ flexDirection: 'column', paddingTop: '5px' }}>
                                                {(getCategoryValue1('P625', 'P625_Model') || P625_MODEL_TPS3200) === P625_MODEL_TPS3200 && (
                                                    <Radio.Group style={{ display: 'flex', flexDirection: 'column', gap: 6 }} onChange={(e) => handleRadioChange('P625', "CMT_Torch", e.target.value)}
                                                        value={getCategoryValue1('P625', 'CMT_Torch')}>
                                                        <Radio value='F-ORIG'>fronius original (Robacta on Bug)</Radio>
                                                        <Radio value='F-NEW'>Fronius Rev 2 (Robacta on Bug)</Radio>
                                                        <Radio value='EWS'>Fronius Rev 3 (Robacta on Torch)</Radio>
                                                    </Radio.Group>
                                                )}
                                                {getCategoryValue1('P625', 'P625_Model') === P625_MODEL_TPS400I && (
                                                    <Radio.Group style={{ display: 'flex' }} onChange={(e) => handleRadioChange('P625', "CMT_Torch", e.target.value)}
                                                        value={getCategoryValue1('P625', 'CMT_Torch')}>
                                                        <Radio value={P625_TORCH_TPS400I_ONLY}>fronius original (Robacta on Torch)</Radio>
                                                    </Radio.Group>
                                                )}
                                            </div>
                                        </Form.Item>
                                        <Form.Item style={{ paddingTop: '0px', paddingLeft: '20px', cursor: 'default' }}
                                            label='Material:'
                                            className='report-radio'
                                        >
                                            <div style={{ display: 'grid', fontSize: '10px' }} className='report-radio'>
                                                <>
                                                    <Radio.Group style={{ display: "flex" }} onChange={(e) => handleRadioChange('P625', "CMT_Material", e.target.value)}
                                                        value={getCategoryValue1('P625', "CMT_Material")}>
                                                        <Radio value='CS'>Carbon steel</Radio>
                                                        <Radio value='SS' >Stainless steel</Radio>
                                                    </Radio.Group>
                                                </>
                                            </div>
                                        </Form.Item>
                                        <Form.Item style={{ paddingTop: '0px', paddingLeft: '20px', cursor: 'default' }}
                                            label='Wire size:'
                                            className='report-radio'
                                        >
                                            <div style={{ flexDirection: 'column', paddingTop: '00px' }}>
                                                <Radio.Group style={{ display: "flex" }}
                                                    onChange={(e) => handleRadioChange('P625', "CMT_Wire_Size", e.target.value)} value={getCategoryValue1('P625', "CMT_Wire_Size")}
                                                >
                                                    <Radio value='1.0' >1.0</Radio>
                                                    <Radio value='1.2'>1.2</Radio>
                                                </Radio.Group>
                                            </div>
                                        </Form.Item>
                                    </div>
                                </div>
                            )}
                        </Col>

                        {/* Right Column - Manual Options */}
                        <Col lg={8}>
                            <div style={{
                                background: 'rgba(255,255,255,0.06)',
                                borderRadius: 8,
                                padding: '16px 14px',
                                border: '1px solid rgba(255,255,255,0.08)'
                            }}>
                                <Text style={{ fontSize: 16, fontWeight: 600, opacity: 0.9, letterSpacing: '0.5px', display: 'block', marginBottom: 14 }}>Manual welding</Text>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 16, fontSize: 14 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <Checkbox
                                    style={{ marginBottom: 0 }}
                                    checked={selectedOptions.ManualRepairs?.enabled || false}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setSelectedOptions((prevOptions) => ({
                                            ...prevOptions,
                                            ManualRepairs: {
                                                enabled: checked,
                                                options: checked ? ['MMA', 'GTAW', 'FCAW', REPAIR_GOUGING] : []
                                            }
                                        }));
                                    }}
                                >Manual Repairs</Checkbox>

                                {selectedOptions.ManualRepairs?.enabled && (
                                    <div style={{ paddingLeft: 8, marginTop: 4 }}>
                                        <Checkbox.Group
                                            value={selectedOptions.ManualRepairs?.options || []}
                                            onChange={(checkedValues) => handleCheckboxChange('ManualRepairs', checkedValues)}
                                            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                                        >
                                            <Checkbox value='MMA' style={{ marginLeft: 0 }}>MMA</Checkbox>
                                            <Checkbox value='GTAW' style={{ marginLeft: 0 }}>GTAW</Checkbox>
                                            <Checkbox value='FCAW' style={{ marginLeft: 0 }}>FCAW</Checkbox>
                                            <Checkbox value={REPAIR_GOUGING} style={{ marginLeft: 0 }}>Repair gouging</Checkbox>
                                        </Checkbox.Group>
                                    </div>
                                )}
                            </div>
                            
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <Checkbox
                                    style={{ marginBottom: 0 }}
                                    checked={selectedOptions.ManualFullScope?.enabled || false}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setSelectedOptions((prevOptions) => ({
                                            ...prevOptions,
                                            ManualFullScope: {
                                                enabled: checked,
                                                options: checked ? ['MMA', 'GTAW', 'FCAW', FULL_SCOPE_GOUGING, FULL_SCOPE_STT] : []
                                            }
                                        }));
                                    }}
                                >Manual Full Scope</Checkbox>

                                {selectedOptions.ManualFullScope?.enabled && (
                                    <div style={{ paddingLeft: 8, marginTop: 4 }}>
                                        <Checkbox.Group 
                                            value={selectedOptions.ManualFullScope?.options || []}
                                            onChange={(checkedValues) => handleCheckboxChange('ManualFullScope', checkedValues)}
                                            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                                        >
                                            <Checkbox value='MMA' style={{ marginLeft: 0 }}>MMA</Checkbox>
                                            <Checkbox value='GTAW' style={{ marginLeft: 0 }}>GTAW</Checkbox>
                                            <Checkbox value='FCAW' style={{ marginLeft: 0 }}>FCAW</Checkbox>
                                            <Checkbox value={FULL_SCOPE_GOUGING} style={{ marginLeft: 0 }}>Full scope Gouging</Checkbox>
                                            <Checkbox value={FULL_SCOPE_STT} style={{ marginLeft: 0 }}>Full scope STT</Checkbox>
                                        </Checkbox.Group>
                                    </div>
                                )}
                            </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Form>


        </div>
    );
};



export default connect(null, null)(WeldingForm);

